export default __webpack_public_path__ + "static/media/Animations_Bar4.92d3489d.svg";